export default [
    {
        path: '/informacion-general',
        name: 'manager.informacion-general',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/informacionGeneral').then(m => m.default || m),
    }
]